import axios from 'axios';
import {
  GET_PATHS,
  GET_PATHS_LIST,
  GET_PATHS_MINIMAL,
  GET_PATH,
  ADD_PATH,
  DELETE_PATH,
  UPDATE_PATH,
  PATHS_LOADING,
  SET_PATHS_PAGE,
  CLEAR_CURRENT_PATH
} from './types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';

// Get all paths (for backward compatibility)
export const getPaths = () => (dispatch, getState) => {
  dispatch({ type: PATHS_LOADING });
  axios
    .get('/api/paths', tokenConfig(getState))
    .then(res => dispatch({ type: GET_PATHS, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

// Get minimal paths list (for dropdowns/selectors - returns only _id and title)
export const getPathsMinimal = () => (dispatch, getState) => {
  dispatch({ type: PATHS_LOADING });
  axios
    .get('/api/paths/minimal', tokenConfig(getState))
    .then(res => dispatch({ type: GET_PATHS_MINIMAL, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};

// Get paginated paths list for table view
export const getPathsList = (page = 1, limit = 10, filters = {}) => (dispatch, getState) => {
  dispatch({ type: PATHS_LOADING });

  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', limit);

  if (filters.title && filters.title.length > 0) {
    filters.title.forEach(title => params.append('title[]', title));
  }
  if (filters.tags && filters.tags.length > 0) {
    filters.tags.forEach(tag => params.append('tags[]', tag));
  }

  axios
    .get(`/api/paths/list?${params.toString()}`, tokenConfig(getState))
    .then(res => dispatch({ type: GET_PATHS_LIST, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

// Get single path by ID
export const getPath = (id) => (dispatch, getState) => {
  dispatch({ type: PATHS_LOADING });
  axios
    .get(`/api/paths/${id}`, tokenConfig(getState))
    .then(res => dispatch({ type: GET_PATH, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

export const addPath = path => (dispatch, getState) => {
  axios
    .post('/api/paths', path, tokenConfig(getState))
    .then(res => dispatch({ type: ADD_PATH, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

export const updatePath = (id, path) => (dispatch, getState) => {
  axios
    .put(`/api/paths/${id}`, path, tokenConfig(getState))
    .then(res => dispatch({ type: UPDATE_PATH, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

export const deletePath = id => (dispatch, getState) => {
  axios
    .delete(`/api/paths/${id}`, tokenConfig(getState))
    .then(res => dispatch({ type: DELETE_PATH, payload: id }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

// Set current page
export const setPathsPage = (page) => {
  return { type: SET_PATHS_PAGE, payload: page };
};

// Clear current path
export const clearCurrentPath = () => {
  return { type: CLEAR_CURRENT_PATH };
};
